import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, SearchIcon, UserIcon, PlusCircleIcon, CameraIcon } from 'lucide-react';
import KreditaLogo from './KreditaLogo';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    t
  } = useLanguage();
  return <header className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="flex justify-between h-16" data-id="element-124">
          <div className="flex items-center" data-id="element-125">
            <Link to="/" className="flex-shrink-0 flex items-center text-primary group" data-id="element-126">
              <KreditaLogo className="transition-transform duration-300 group-hover:scale-105" data-id="element-127" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-8" data-id="element-128">
            <Link to="/browse" className="text-gray-700 hover:text-primary px-3 py-2 text-sm font-medium transition-colors relative group" data-id="element-129">
              {t.nav.browse}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" data-id="element-130"></span>
            </Link>
            <Link to="/services" className="flex items-center text-gray-700 hover:text-primary px-3 py-2 text-sm font-medium transition-colors relative group" data-id="element-131">
              <CameraIcon className="h-4 w-4 mr-1.5" data-id="element-132" />
              {t.nav.services}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" data-id="element-133"></span>
            </Link>
            <Link to="/create-listing" className="flex items-center text-gray-700 hover:text-primary px-3 py-2 text-sm font-medium transition-colors relative group" data-id="element-134">
              <PlusCircleIcon className="h-4 w-4 mr-1.5" data-id="element-135" />
              {t.nav.listProperty}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" data-id="element-136"></span>
            </Link>
            <Link to="/dashboard" className="text-gray-700 hover:text-primary px-3 py-2 text-sm font-medium transition-colors relative group" data-id="element-137">
              {t.nav.dashboard}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full" data-id="element-138"></span>
            </Link>
            <LanguageSwitcher data-id="element-139" />
            <Link to="/login" className="btn-primary" data-id="element-140">
              {t.nav.login}
            </Link>
          </div>
          {/* Mobile menu button */}
          <div className="flex items-center md:hidden space-x-2" data-id="element-141">
            <LanguageSwitcher data-id="element-142" />
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-primary hover:bg-gray-50 focus:outline-none transition-colors" data-id="element-143">
              {isMenuOpen ? <XIcon className="block h-6 w-6" data-id="element-144" /> : <MenuIcon className="block h-6 w-6" data-id="element-145" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden border-t border-gray-100 bg-white" data-id="element-146">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-147">
            <Link to="/browse" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-148">
              {t.nav.browse}
            </Link>
            <Link to="/services" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-149">
              {t.nav.services}
            </Link>
            <Link to="/create-listing" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-150">
              {t.nav.listProperty}
            </Link>
            <Link to="/dashboard" className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-primary hover:bg-gray-50 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-151">
              {t.nav.dashboard}
            </Link>
            <Link to="/login" className="block px-3 py-2 rounded-md text-base font-medium bg-primary text-white hover:bg-[rgb(var(--color-primary-dark))] transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-152">
              {t.nav.login}
            </Link>
          </div>
        </div>}
    </header>;
};
export default Header;